import Marquee from "react-fast-marquee";
import { Droplet } from "lucide-react";

const ITEMS = [
  "Research Reagent",
  "Bacteriostatic Water",
  "Sterile Packaging",
  "Laboratory Use Only",
  "Not for Human Use",
  "Not for Veterinary Use",
];

export default function EditorialMarquee() {
  return (
    <div
      className="border-y border-slate-200 bg-white py-5 overflow-hidden max-w-full"
      data-testid="editorial-marquee"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span
            key={item}
            className="flex items-center gap-6 mx-6 font-plexmono text-xs tracking-[0.3em] uppercase text-slate-400"
          >
            {item}
            <Droplet className="w-3 h-3 text-slate-300" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
